import HttpService from './HttpService';

const UserAdminApi = HttpService('/api/useradmin/');
const doPost = (action, data) => UserAdminApi.post(action, data);
const doGet = (url) => UserAdminApi.get(url);

export default {
  getUsers(usersFilter) { // eslint-disable-line no-unused-vars
    const queryString = null;
    const apiAction = 'GetUsers';
    const fullUrl = queryString ? `${apiAction}?${queryString}` : apiAction;
    return doGet(fullUrl);
  },
  getAssignableRoles() {
    const apiAction = 'GetAssignableRoles';
    return doGet(apiAction);
  },
  getAvailableNotifications() {
    const queryString = null;
    const apiAction = 'GetAvailableNotifications';
    const fullUrl = queryString ? `${apiAction}?${queryString}` : apiAction;
    return doGet(fullUrl);
  },
  assignRoleToUser({ userId, role }) {
    return doPost('AssignRolesToUser', { userId, roles: [role] });
  },
  removeRoleFromUser({ userId, role }) {
    return doPost('RemoveRolesFromUser', { userId, roles: [role] });
  },
  assignPoolToUser({ userId, pool }) {
    return doPost('AssignPoolsToUser', { userId, pools: [pool] });
  },
  removePoolFromUser({ userId, pool }) {
    return doPost('RemovePoolsFromUser', { userId, pools: [pool] });
  },
  assignSiteToUser({ userId, site }) {
    return doPost('AssignSitesToUser', { userId, sites: [site] });
  },
  removeSiteFromUser({ userId, site }) {
    return doPost('RemoveSitesFromUser', { userId, sites: [site] });
  },
  assignVesselToUser({ userId, vessel }) {
    return doPost('AssignVesselsToUser', { userId, vessels: [vessel.name] });
  },
  removeVesselFromUser({ userId, vessel }) {
    return doPost('RemoveVesselsFromUser', { userId, vessels: [vessel.name] });
  },
  assignNotificationToUser(assignedNotification) {
    return doPost('AssignNotificationToUser', assignedNotification);
  },
  removeNotificationFromUser(notification) {
    return doPost('RemoveNotificationFromUser', notification);
  },
  resetUserPassword({ userId, newPassword }) {
    return doPost('ResetUserPassword', { userId, newPassword });
  },
  disableUserUpdate(userId, disabledBool) {
    return doPost('DisableUserUpdate', { userId, disabled: disabledBool });
  },
  enableUser(userId) {
    return doPost('EnableUserAccount', userId);
  },
  deleteUser({ userId }) {
    return doPost('DeleteUser', { userId });
  },
  createUser({ userName, userEmail, userPassword }) {
    return doPost('CreateNewUser', { userName, userEmail, userPassword });
  },
};
